<hr>
<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="toolbar">
            <div class="row" style="margin-right: 0px; margin-left: 0px">
              <div class="col-md-12">
                <input type="text" class="form-control" style="height: 34px" placeholder="Pesquisar..."
                  [(ngModel)]="pesquisa" (keyup.enter)="pesquisar()" />
              </div>
            </div>
            <div class="row" style="margin-right: 0px; margin-left: 0px; text-align: right">
              <div class="col-md-12" style="text-align: right">
                <div style="margin-top: 5px !important; float: right">
                  <div class="" id="button-addon4" style="text-align: right">
                    <button class="btn btn-outline-secondary" style="margin-top: 0; height: 40px" (click)="pesquisar()">
                      <i class="fa fa-search"></i>
                    </button>
                    <button class="btn btn-outline-secondary" style="margin-top: 0; height: 40px" (click)="atualizar()">
                      <i class="fa fa-refresh"></i>
                    </button>
              
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="table-responsive table-hover" style="overflow-y: hidden; overflow-x: auto">
            <table class="table" *ngIf="!loading">
              <thead class="">
                <tr>
                  <th scope="col">Nr. Patrimonio</th>
                  <th>Descrição do bem</th>
                  <th>Nome de Origem</th>
                  <th>Nome de destino</th>
                  <!-- <th>Nome do Gestor</th> -->
                  <th>Tipo de Movimentação</th>
                  <th class="text-right"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let mov of page.dados">
                  <th scope="row">
                    {{mov.dS_BPM_ETIQUETA_BEM != null ? mov.dS_BPM_ETIQUETA_BEM : '#'}}
                  </th>
                    <td>
                      {{mov.dS_BPM_DESCRICAO_BEM}}
                    </td>
                  <td class="text-truncate">
                    {{mov.dS_NM_ORIGEM}}</td>
                  <td scope="row">{{mov.dS_NM_DESTINO}}

                  </td>
                  <!-- <td>
                    {{mov.dS_NM_GESTOR}}</td> -->
                  <td>
                    {{mov.dS_BPM_TIPO_MOVIMENTACAO_PATRIMONIAL}}</td>
                  <td class="actions text-right">
                    <a class="btn btn-icon btn-neutral btn-twitter" (click)="aprovar(mov.nR_BPM_BEM_PATRIMONIAL)">
                      <i class="bi bi-check2-circle"></i>
                    </a>
                  </td>
                  <td class="actions text-right">
                    <a class="btn btn-icon btn-neutral btn-pinterest" (click)="abreEdicao(mov.nR_BPM_BEM_PATRIMONIAL)">
                      <i class="bi bi-x"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="row" *ngIf="page.dados && !loading">
              <div class="col-md-12">
                  <ul class="pagination" *ngIf="page.pages.length > 0">
                      <li class="page-item" [ngClass]="{ disabled: page.currentPage === 1 }" title="Primeira página">
                          <a class="page-link" aria-label="Primeira página" (click)="setPage(1)">
                              <span aria-hidden="true"><i
                      class="fa fa-angle-double-left"
                      aria-hidden="true"
                    ></i
                  ></span>
                          </a>
                      </li>
                      <li class="page-item" title="Página anterior" [ngClass]="{ disabled: page.currentPage === 1 }">
                          <a class="page-link" aria-label="Página anterior" (click)="setPage(page.currentPage - 1)">
                              <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i
                  ></span>
                          </a>
                      </li>
                      <li *ngFor="let page of page.pages" class="" [ngClass]="{ 'page-item': true, active: paginaAtual(page)}" [attr.title]="'Página ' + page">
                          <a class="page-link" (click)="setPage(page)">{{ page }}</a>
                      </li>
                      <li class="page-item" title="Próxima página" [ngClass]="{
                  disabled: page.currentPage === page.totalPages
                }">
                          <a class="page-link" aria-label="Próxima página" (click)="setPage(page.currentPage + 1)">
                              <span aria-hidden="true"><i class="fa fa-angle-right" aria-hidden="true"></i
                  ></span>
                          </a>
                      </li>
                      <li class="page-item" title="Última página" 
                      [ngClass]="{ disabled: page.currentPage === page.totalPages }">
                          <a class="page-link" aria-label="Última página" (click)="setPage(page.totalPages)">
                              <span aria-hidden="true"><i
                      class="fa fa-angle-double-right"
                      aria-hidden="true"
                    ></i
                  ></span>
                          </a>
                      </li>
                  </ul>
              </div>
          </div>
            <div class="row">
              <div class="col-md-12 text-center" *ngIf="loading">
                <img src="./assets/img/loading.png" class="loading" id="loadingImage" height="50" width="50" />
              </div>
            </div>
            <div class="row">
              <div
                class="col-md-12 text-center"
                *ngIf="page.dados?.length == 0 && !loading"
              >
                <h5>Não há dados para exibir</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>